
























import { Component, Vue } from 'vue-property-decorator';
import { PermissionType } from '@shared/common/types';
import { deviceApi } from '../device.api';
import PushNotifConfirmModal from './PushNotifConfirmModal.vue';

@Component
export default class PushNotifDropdown extends Vue {
  public isModalActive = false;
  public PermissionType = PermissionType;

  public pushNotifConfigs = [
    {
      type: 'TOS_UPDATE',
      label: 'Changement des CGU',
      confirmModalProps: {
        title: 'Mise à jour des CGU - Notification des terminaux',
        content:
          'Vous allez envoyer une notification aux terminaux LEA concernant la mise à jour des CGU / politique de confidentialité.',
      },
      needConfirm: true,
    },
  ];

  public getNotifyAction(pushNotifConfig: any) {
    return async (): Promise<boolean> => {
      try {
        await deviceApi.sendPushNotification(pushNotifConfig.type);
        this.$buefy.snackbar.open({
          message: 'Notifications envoyées',
          queue: false,
        });
        return true;
      } catch (_) {
        this.$buefy.snackbar.open({
          type: 'is-danger',
          message: 'Une erreur est survenue',
          queue: false,
        });
      }

      return false;
    };
  }

  public async notify(pushNotifConfig: any): Promise<void> {
    if (pushNotifConfig.needConfirm) {
      this.$buefy.modal.open({
        hasModalCard: true,
        component: PushNotifConfirmModal,
        props: {
          ...pushNotifConfig.confirmModalProps,
          notifyAction: this.getNotifyAction(pushNotifConfig),
        },
      });
    }

    // try {
    //   await deviceApi.sendPushNotification(pushNotifConfig.type);
    //   this.$buefy.snackbar.open({
    //     message: 'Notifications envoyées',
    //     queue: false,
    //   });
    // } catch (_) {
    //   this.$buefy.snackbar.open({
    //     type: 'is-danger',
    //     message: 'Une erreur est survenue',
    //     queue: false,
    //   });
    // }
  }

  public cancel(): void {
    this.isModalActive = false;
  }
}
